(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["astondiy-fault-codes"]) return;
  try {
    
(() => {
  const roots = document.querySelectorAll('[data-fault-code-section]');
  roots.forEach((root) => {
    if (root.dataset.enhanced === 'true') return;
    root.dataset.enhanced = 'true';
    const legacyLookup = root.querySelector('.astondiy-lookup');
    if (legacyLookup) legacyLookup.remove();
    const table = root.querySelector('[data-code-table] table');
    if (!table) return;
    const manualData = {};
    document.querySelectorAll('[data-dtc-manual-data]').forEach((element) => Object.assign(manualData, JSON.parse(element.textContent)));
    const rows = Array.from(table.querySelectorAll('tr')).filter((row) => row.querySelectorAll('td').length >= 2);
    const search = root.querySelector('[data-code-search]');
    const system = root.querySelector('[data-system-filter]');
    const count = root.querySelector('[data-result-count]');
    const empty = root.querySelector('[data-empty-state]');
    const pagination = root.querySelector('[data-pagination]');
    const status = root.querySelector('[data-page-status]');
    const previous = root.querySelector('[data-page-prev]');
    const next = root.querySelector('[data-page-next]');
    const dialog = root.querySelector('[data-code-dialog]');
    const dialogCode = root.querySelector('[data-dialog-code]');
    const dialogDescription = root.querySelector('[data-dialog-description]');
    const dialogFamily = root.querySelector('[data-dialog-family]');
    const dialogSystem = root.querySelector('[data-dialog-system]');
    const dialogDiagnostic = root.querySelector('[data-dialog-diagnostic]');
    const dialogSources = root.querySelector('[data-dialog-sources]');
    const pageSize = 50;
    let page = 1;
    const classify = (code, description) => {
      const text = `${code} ${description}`.toLowerCase();
      if (/oxygen|o2|ho2s|lambda/.test(text)) return 'oxygen';
      if (/misfire|ignition|spark|knock sensor|coil/.test(text)) return 'misfire';
      if (/evaporative|evap|emission|catalyst|exhaust gas|secondary air|purge|canister/.test(text)) return 'emissions';
      if (/transmission|gear|shift|clutch|torque converter|tcm|turbine|parklock|prnd/.test(text)) return 'transmission';
      if (/coolant|temperature|thermostat|fan control|overtemperature/.test(text)) return 'cooling';
      if (/fuel|air flow|maf|manifold|throttle|injector|pressure sensor/.test(text)) return 'fuel';
      if (/voltage|battery|alternator|module|ecu|ecm|pcm|circuit|can /.test(text)) return 'electrical';
      return 'other';
    };
    const familyNames = { P: 'Powertrain', B: 'Body', C: 'Chassis', U: 'Network communication' };
    const systemNames = { emissions: 'Emissions and EVAP', oxygen: 'Oxygen sensors', misfire: 'Misfire and ignition', fuel: 'Fuel and air', cooling: 'Cooling and temperature', transmission: 'Transmission', electrical: 'Electrical and control modules', other: 'Other vehicle system' };
    const escapeHtml = (value) => String(value).replace(/[&<>'"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[character]);
    const diagnosticStartingPoint = (code, description, details, systemKey) => {
      const text = description.toLowerCase();
      const checks = ['Record all stored and pending codes, freeze-frame information and the conditions in which the fault appeared.'];
      const cautions = ['Treat the code as evidence of a detected condition, not proof that the named component must be replaced.'];
      if (/low input|low voltage|short to ground/.test(text)) checks.push('Inspect the connector and harness for an open supply, poor contact, damaged wiring or a short to ground, then verify supply, ground and signal values.');
      else if (/high input|high voltage|short to (battery|power|voltage)/.test(text)) checks.push('Inspect the connector and harness for an open ground or a short to supply voltage, then verify ground, reference and signal values.');
      else if (/intermittent|erratic/.test(text)) checks.push('Inspect for loose terminals, chafed wiring, heat or moisture damage and use live data or a careful harness movement check to reproduce the interruption.');
      else if (/range|performance|correlation|plausib/.test(text)) checks.push('Compare the affected live-data value with the related sensor or expected operating value; inspect for mechanical or airflow causes before assuming an electrical failure.');
      else if (/open|circuit|control module|ecu|pcm|tcm/.test(text)) checks.push('Inspect the relevant fuse, power supply, ground, connector and harness continuity before testing or replacing the controlled component.');
      if (systemKey === 'oxygen') checks.push('Confirm the correct bank and sensor position, inspect nearby exhaust leaks and compare the signal with the equivalent sensor on the other bank.');
      if (systemKey === 'misfire') checks.push('Check related cylinder, injector, ignition, camshaft and crankshaft codes first; then check ignition, fuelling, intake leaks and mechanical condition.');
      if (systemKey === 'emissions') checks.push('Inspect the relevant hoses, valves, connectors and exhaust or vapour lines for leaks, damage or disconnection before component replacement.');
      if (systemKey === 'fuel') checks.push('Check intake integrity, fuel pressure and related sensor readings under the conditions that set the code.');
      if (systemKey === 'cooling') checks.push('Check coolant level and condition when safe, then inspect the sensor circuit, thermostat or fan operation relevant to the description.');
      if (systemKey === 'transmission') checks.push('Check fluid condition and level using the correct procedure, related transmission codes, connector condition and live selector or speed data.');
      if (code.charAt(0) === 'U') checks.push('Check battery voltage, module power and grounds, network connectors and related communication codes before suspecting a control module.');
      const hasProcedure = Boolean(details.db9 && details.db9.printedPage);
      return {
        label: 'Diagnostic starting point',
        context: hasProcedure
          ? 'The DB9 manual contains a model-specific fault-analysis section for this code. The checks below help organise the initial investigation; use the cited section for measurements and decision points.'
          : details.vantage
            ? 'The available V8 Vantage preliminary manual provides the code definition and warning-lamp status, but no code-specific fault-analysis procedure. These are general starting checks and are not represented as an Aston Martin test sequence.'
            : 'No additional procedure was matched reliably in the two available preliminary manuals. These are general starting checks only.',
        checks: [...new Set(checks)].slice(0, 4),
        cautions
      };
    };
    const sourceCard = (name, issue, details, url) => {
      const pageLine = details.printedPage ? `<dt>Manual section</dt><dd>${escapeHtml(details.printedPage)}</dd>` : '';
      return `<article class="ad-dtc__source"><div class="ad-dtc__source-head"><h3>${escapeHtml(name)}</h3><span class="ad-dtc__source-badge">Manual match</span></div><dl><dt>Manual issue</dt><dd>${escapeHtml(issue)}</dd><dt>Warning lamp status</dt><dd>${escapeHtml(details.mil)}</dd>${pageLine}</dl><a href="${escapeHtml(url)}" target="_blank" rel="noreferrer">Open the relevant manual reference</a></article>`;
    };
    const manualProcedure = (details) => {
      const procedure = details.db9 && details.db9.procedure;
      if (!procedure || (!procedure.definition && !(procedure.cautions || []).length && !(procedure.steps || []).length)) return '';
      const definition = procedure.definition ? `<h4>Manual fault definition</h4><p>${escapeHtml(procedure.definition)}</p>` : '';
      const cautions = (procedure.cautions || []).map((item) => `<div class="ad-dtc__manual-caution"><strong>${escapeHtml(item.type)}</strong><p>${escapeHtml(item.text)}</p></div>`).join('');
      const steps = (procedure.steps || []).map((item) => `<li>${escapeHtml(item.text)}</li>`).join('');
      return `<details class="ad-dtc__manual-procedure" open><summary>DB9 manufacturer fault-analysis procedure</summary>${definition}${cautions}${steps ? `<h4>Test sequence and decision path</h4><ol>${steps}</ol>` : ''}</details>`;
    };
    const openDetail = (row) => {
      const cells = row.querySelectorAll('td');
      const code = cells[0].textContent.trim().toUpperCase();
      const description = cells[1].textContent.trim();
      const details = manualData[code] || {};
      const sources = [];
      if (details.vantage) sources.push(sourceCard('V8 Vantage', 'January 2006 preliminary issue', details.vantage, 'https://cdn.shopify.com/s/files/1/0811/6663/1230/files/V8_VANTAGE._OBD_II_Diagnostic_Manual_Preliminary_Issue.pdf?v=1705061202'));
      if (details.db9) {
        const pageAnchor = details.db9.pdfPage ? `#page=${details.db9.pdfPage}` : '';
        sources.push(sourceCard('DB9', 'April 2004 preliminary issue', details.db9, `https://cdn.shopify.com/s/files/1/0811/6663/1230/files/aston-martin-db9-obd-ii-diagnostic-manual-preliminary-issue-2004.pdf?v=1705061411${pageAnchor}`));
      }
      if (!sources.length) sources.push('<article class="ad-dtc__source"><h3>No additional manual match</h3><p>This code is retained in the consolidated AstonDIY list, but an additional entry could not be matched reliably in the two linked preliminary manuals.</p></article>');
      dialogCode.textContent = code;
      dialogDescription.textContent = description;
      dialogFamily.textContent = familyNames[code.charAt(0)] || 'Manufacturer-specific';
      dialogSystem.textContent = systemNames[row.dataset.system] || systemNames.other;
      const summary = details.summary || diagnosticStartingPoint(code, description, details, row.dataset.system);
      const checks = (summary.checks || []).map((item) => `<li>${escapeHtml(item)}</li>`).join('');
      const cautions = (summary.cautions || []).map((item) => `<li>${escapeHtml(item)}</li>`).join('');
      dialogDiagnostic.innerHTML = `<h3>${escapeHtml(summary.label || 'Diagnostic summary')}</h3>${summary.context ? `<p>${escapeHtml(summary.context)}</p>` : ''}${checks ? `<strong>Start with these checks</strong><ol>${checks}</ol>` : ''}${cautions ? `<strong>Important cautions</strong><ul>${cautions}</ul>` : ''}${manualProcedure(details)}`;
      dialogDiagnostic.hidden = false;
      dialogSources.innerHTML = sources.join('');
      if (history.replaceState) history.replaceState(null, '', `#${row.id}`);
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
    };
    rows.forEach((row) => {
      const cells = row.querySelectorAll('td');
      const code = cells[0].textContent.trim().toUpperCase();
      const description = cells[1].textContent.trim();
      row.dataset.search = `${code} ${description}`.toLowerCase();
      row.dataset.system = classify(code, description);
      const id = `dtc-${code.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`;
      if (!document.getElementById(id)) {
        row.id = id;
        const link = document.createElement('a');
        link.href = `/pages/aston-martin-fault-codes/${code.toLowerCase()}`;
        link.textContent = code;
        link.setAttribute('aria-label', `Link to fault code ${code}`);
        cells[0].textContent = '';
        cells[0].appendChild(link);
      }
      const link = cells[0].querySelector('a');
      if (link) link.addEventListener('click', (event) => { event.preventDefault(); openDetail(row); });
    });
    const update = () => {
      const term = search.value.trim().toLowerCase();
      const selectedSystem = system.value;
      const matches = rows.filter((row) => (!term || row.dataset.search.includes(term)) && (selectedSystem === 'all' || row.dataset.system === selectedSystem));
      const pages = Math.max(1, Math.ceil(matches.length / pageSize));
      page = Math.min(page, pages);
      rows.forEach((row) => { row.hidden = true; });
      matches.slice((page - 1) * pageSize, page * pageSize).forEach((row) => { row.hidden = false; });
      count.textContent = `${matches.length} ${matches.length === 1 ? 'result' : 'results'}`;
      status.textContent = matches.length ? `Page ${page} of ${pages}` : '';
      previous.disabled = page <= 1;
      next.disabled = page >= pages;
      empty.hidden = matches.length !== 0;
      pagination.hidden = matches.length <= pageSize;
    };
    const resetPageAndUpdate = () => { page = 1; update(); };
    search.addEventListener('input', resetPageAndUpdate);
    system.addEventListener('change', resetPageAndUpdate);
    root.querySelector('[data-clear-search]').addEventListener('click', () => { search.value = ''; system.value = 'all'; resetPageAndUpdate(); search.focus(); });
    root.querySelectorAll('[data-topic]').forEach((button) => button.addEventListener('click', () => { search.value = button.dataset.topic; system.value = 'all'; resetPageAndUpdate(); root.querySelector('.ad-dtc__lookup').scrollIntoView({ behavior: 'smooth', block: 'start' }); }));
    previous.addEventListener('click', () => { if (page > 1) { page -= 1; update(); root.querySelector('.ad-dtc__lookup-heading').scrollIntoView({ behavior: 'smooth', block: 'start' }); } });
    next.addEventListener('click', () => { page += 1; update(); root.querySelector('.ad-dtc__lookup-heading').scrollIntoView({ behavior: 'smooth', block: 'start' }); });
    root.querySelector('[data-dialog-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
    update();
    if (location.hash.startsWith('#dtc-')) {
      const linkedRow = root.querySelector(location.hash);
      if (linkedRow) openDetail(linkedRow);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
